export function AssertUnreachable(x: never, message: string): never {
	throw new Error(message)
}
